'use client';
import React from 'react';
var ButtonGroupContext = /*#__PURE__*/React.createContext(null);
export default ButtonGroupContext;